"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setEditorDynoId = setEditorDynoId;
exports.changeEditorStep = changeEditorStep;
exports.clearEditableDyno = clearEditableDyno;
exports.requestDynoCreation = requestDynoCreation;
exports.autoSaveDyno = autoSaveDyno;
exports.cancelAutoSaveDyno = cancelAutoSaveDyno;
exports.saveDyno = saveDyno;
exports.saveDynoDraft = saveDynoDraft;
exports.createDynoSuccess = createDynoSuccess;
exports.saveDynoSuccess = saveDynoSuccess;
exports.saveDraftSuccess = saveDraftSuccess;
exports.saveDynoError = saveDynoError;
exports.saveDraftError = saveDraftError;
exports.issueNoChangesNotification = issueNoChangesNotification;
exports.deleteDynoDraft = deleteDynoDraft;
exports.fetchDynoForEditorIfNeeded = fetchDynoForEditorIfNeeded;
exports.updateDyno = updateDyno;
exports.addValidationErrorIfNeeded = addValidationErrorIfNeeded;
exports.removeValidationErrorIfNeeded = removeValidationErrorIfNeeded;
exports.removeAllValidationErrors = removeAllValidationErrors;
exports.saveChangesToDyno = saveChangesToDyno;
exports.getDraftChangesIfNeeded = getDraftChangesIfNeeded;
exports.saveDynoChangesToDraft = saveDynoChangesToDraft;
exports.addFormField = addFormField;
exports.removeFormField = removeFormField;
exports.editFormField = editFormField;
exports.editFormFieldValidation = editFormFieldValidation;
exports.moveFormField = moveFormField;
exports.fetchKickbackPreviews = fetchKickbackPreviews;

var _I18n = _interopRequireDefault(require("I18n"));

var _underscore = require("underscore");

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _Dynos = require("./Dynos");

var _DynosApiClient = _interopRequireDefault(require("lead-flows-ui/api/DynosApiClient"));

var _NotificationUtils = require("lead-flows-ui/utils/NotificationUtils");

var _DynoUtils = require("lead-flows-ui/utils/DynoUtils");

var _DynoEditor = require("lead-flows-ui/constants/DynoEditor");

var _Dynos2 = require("lead-flows-ui/selectors/Dynos");

var _FormFieldTypes = _interopRequireDefault(require("lead-flows-ui/constants/FormFieldTypes"));

var _eventsTrackerUtils = require("lead-flows-ui/utils/eventsTrackerUtils");

var _FormFieldUtils = require("lead-flows-ui/utils/FormFieldUtils");

var _ErrorUtils = require("lead-flows-ui/utils/ErrorUtils");

var _DynoValidationUtils = require("lead-flows-ui/utils/Validation/DynoValidationUtils");

function setEditorDynoId(id) {
  return {
    type: _ActionTypes.SET_EDITOR_DYNO_ID,
    payload: {
      id: id
    }
  };
}

function changeEditorStep(step) {
  return {
    type: _ActionTypes.SET_EDITOR_STEP,
    payload: {
      step: step
    }
  };
}

function addValidationError(step, field, message) {
  return {
    type: _ActionTypes.ADD_VALIDATION_ERROR,
    payload: {
      step: step,
      field: field,
      message: message
    }
  };
}

function removeValidationError(step, field) {
  return {
    type: _ActionTypes.REMOVE_VALIDATION_ERROR,
    payload: {
      step: step,
      field: field
    }
  };
}

function updateEditableDyno(update) {
  return {
    type: _ActionTypes.UPDATE_EDITABLE_DYNO,
    payload: update
  };
}

function clearEditableDyno() {
  return {
    type: _ActionTypes.CLEAR_EDITABLE_DYNO
  };
}

function requestDynoForEditor() {
  return {
    type: _ActionTypes.REQUEST_DYNO_FOR_EDITOR
  };
}

function recieveDynoForEditor(dyno) {
  return {
    type: _ActionTypes.RECIEVE_DYNO_FOR_EDITOR,
    payload: dyno
  };
}

function errorDynoForEditor(error) {
  return {
    type: _ActionTypes.ERROR_DYNO_FOR_EDITOR,
    payload: error,
    error: true
  };
}

function fixFormFieldOrders(formFields) {
  // Fixes duplicates or gaps in field orders,
  // eg [0, 1, 1, 4, 6] => [0, 1, 2, 3, 4].
  var sortedFields = (0, _underscore.sortBy)(formFields, 'displayOrder');
  sortedFields.forEach(function (field, index) {
    field.displayOrder = index;
  });
  return sortedFields;
}

function fetchDynoForEditor(id) {
  return function (dispatch) {
    dispatch(requestDynoForEditor());
    return _DynosApiClient.default.fetchDyno(id).then(function (response) {
      response.formFields = fixFormFieldOrders(response.formFields);
      dispatch((0, _Dynos.receiveDynoById)(response));
      dispatch(recieveDynoForEditor(response));
    }, function (error) {
      dispatch(errorDynoForEditor(error.xhr));
    }).done();
  };
}

function requestKickbacks() {
  return {
    type: _ActionTypes.REQUEST_KICKBACKS
  };
}

function errorKickbacks() {
  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 400;
  return {
    type: _ActionTypes.ERROR_KICKBACKS,
    payload: status
  };
}

function requestDynoCreation() {
  return {
    type: _ActionTypes.REQUEST_DYNO_CREATION
  };
}

function autoSaveDyno() {
  return {
    type: _ActionTypes.AUTO_SAVE_DYNO
  };
}

function cancelAutoSaveDyno() {
  return {
    type: _ActionTypes.CANCEL_AUTO_SAVE_DYNO
  };
}

function saveDyno() {
  return {
    type: _ActionTypes.SAVE_DYNO
  };
}

function saveDynoDraft() {
  return {
    type: _ActionTypes.SAVE_DRAFT
  };
}

function createDynoSuccess(dyno) {
  return {
    type: _ActionTypes.CREATE_DYNO_SUCCESS,
    payload: dyno
  };
}

function saveDynoSuccess(dyno) {
  return {
    type: _ActionTypes.SAVE_DYNO_SUCCESS,
    payload: dyno,
    meta: {
      timestamp: Date.now()
    }
  };
}

function saveDraftSuccess(dyno) {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.SAVE_DRAFT_SUCCESS,
      payload: dyno,
      meta: {
        timestamp: Date.now()
      }
    });
  };
}

function saveDynoError(error) {
  return {
    type: _ActionTypes.SAVE_DYNO_ERROR,
    payload: error
  };
}

function getErrorMessage(_ref) {
  var status = _ref.status,
      response = _ref.response;

  var defaultError = _I18n.default.text('leadFlowEditor.secondaryNavigation.save.draftSaveError');

  var _parseResponseJson = (0, _ErrorUtils.parseResponseJson)(response),
      errorType = _parseResponseJson.errorType;

  switch (status) {
    case 412:
      return _I18n.default.text('leadFlows.error.concurrentUpdates');

    case 400:
      return _I18n.default.text("leadFlowEditor.error." + errorType, {
        defaultValue: defaultError
      });

    default:
      return defaultError;
  }
}

function saveDraftError(error) {
  var message = getErrorMessage(error);
  return {
    type: _ActionTypes.SAVE_DRAFT_ERROR,
    payload: error,
    meta: {
      notification: {
        titleText: _I18n.default.text('leadFlowEditor.secondaryNavigation.save.draftSaveErrorTitle'),
        message: message,
        type: 'danger'
      }
    }
  };
}

function issueNoChangesNotification() {
  return {
    type: _ActionTypes.SAVE_DRAFT_NO_CHANGES,
    meta: {
      notification: {
        message: _I18n.default.text('leadFlowEditor.secondaryNavigation.save.draftNoChanges')
      }
    }
  };
}

function requestDynoDraftDelete() {
  return {
    type: _ActionTypes.DELETE_DRAFT
  };
}

function receiveDynoDraftDelete(id) {
  return {
    type: _ActionTypes.DELETE_DRAFT_SUCCESS,
    payload: {
      id: id
    },
    meta: {
      notification: (0, _NotificationUtils.createTopNotification)('success', _I18n.default.text('notification.removeDynoDraft.success'))
    }
  };
}

function errorDynoDraftDelete() {
  return {
    type: _ActionTypes.DELETE_DRAFT_ERROR,
    meta: {
      notification: (0, _NotificationUtils.createTopNotification)('danger', _I18n.default.text('notification.removeDynoDraft.error'))
    }
  };
}

function receiveKickbackPreviews(emailData) {
  return {
    type: _ActionTypes.RECEIVE_KICKBACK_PREVIEWS,
    payload: emailData
  };
}

function kickBackEmailsErrors(field) {
  var fieldToError = {
    emailSubjectLine: 'includeSubjectLine',
    emailMessageHtml: 'includeEmailMessage',
    emailSenderUserId: 'selectVerifiedUser'
  };
  return "leadFlowEditor.leadFlowFollowUpEmailEditor.error." + fieldToError[field];
}

function validateKickbackEmails(dispatch, field, state) {
  var kickbackEmails = state.dynosEditor.editableDyno.kickbackEmails;
  var errorMessage = kickBackEmailsErrors(field);
  kickbackEmails.forEach(function (email, idx) {
    if (!email.emailData[field]) {
      dispatch(addValidationError('follow-up', field + "_" + idx, errorMessage));
    }
  });
}

function deleteDynoDraft(id) {
  return function (dispatch) {
    dispatch(requestDynoDraftDelete());
    return _DynosApiClient.default.deleteDynoDraft(id).then(function () {
      dispatch(receiveDynoDraftDelete(id));
      (0, _eventsTrackerUtils.trackEditorInteraction)('delete-lead-flow-draft');
    }, function () {
      dispatch(errorDynoDraftDelete());
      (0, _eventsTrackerUtils.trackEditorInteraction)('delete-lead-flow-draft-failure');
    }).done();
  };
}

function fetchDynoForEditorIfNeeded(id) {
  return function (dispatch, getState) {
    var dynoById = getState().dynos.dynosById[id];

    if (!dynoById) {
      return dispatch(fetchDynoForEditor(id));
    }

    return dispatch(recieveDynoForEditor(dynoById));
  };
}

function updateDyno(changes, shouldAutoSave) {
  return function (dispatch, getState) {
    // Update default triggers when type changes.
    if (changes.type && changes.type !== (0, _Dynos2.getType)(getState())) {
      changes = Object.assign({}, changes, (0, _DynoUtils.getDefaultTriggers)(changes.type));
    }

    dispatch(updateEditableDyno(changes)); // prevent validation errors to pop when a new email is created or deleted

    if (shouldAutoSave) {
      dispatch(autoSaveDyno()); // eslint-disable-next-line

      autoSaveDraft(dispatch, getState);
    }
  };
}

function addValidationErrorIfNeeded(step, field, message) {
  return function (dispatch, getState) {
    var v = getState().dynosEditor.validation;

    if (v[step] === undefined || v[step][field] === undefined) {
      return dispatch(addValidationError(step, field, message));
    }

    return null;
  };
}

function removeValidationErrorIfNeeded(step, field) {
  return function (dispatch, getState) {
    var v = getState().dynosEditor.validation;

    if (v[step] !== undefined && v[step][field] !== undefined) {
      return dispatch(removeValidationError(step, field));
    }

    return null;
  };
}

function removeAllValidationErrors() {
  return function (dispatch) {
    return dispatch({
      type: _ActionTypes.RESET_VALIDATION_ERRORS
    });
  };
}

function saveChangesToDyno() {
  var postSave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return function (dispatch, getState) {
    dispatch(saveDyno());
    var dyno = Object.assign({}, getState().dynosEditor.editableDyno, {
      draft: false
    });
    return _DynosApiClient.default.putDyno(dyno).then(function (response) {
      dispatch(saveDynoSuccess(response));
      dispatch((0, _Dynos.receiveDynoById)(response));

      if (postSave) {
        postSave();
      }

      try {
        var type = dyno.type ? dyno.type.toLowerCase().replace('_', '-') : null;
        var featuredImage = Boolean(dyno.imageResizedUrl);
        var calloutBody = Boolean(dyno.description);
        var formBody = Boolean(dyno.formDescription);
        var language = dyno.locale;
        var redirectType = dyno.redirectButtonType ? dyno.redirectButtonType.toLowerCase().replace('_', '-') : null;
        var calloutType = dyno.calloutButtonType;
        var singleFollowUpEmail = dyno.kickbackEmails ? dyno.kickbackEmails.length === 1 : false;
        var multiFollowUpEmail = dyno.kickbackEmails ? dyno.kickbackEmails.length > 1 : false;
        var displayOnExitIntent = dyno.displayOnExitIntent;
        var displayOnMobile = dyno.displayOnMobile;
        var displayOnScroll = dyno.displayOnScroll;
        var displayOnTimedDelay = dyno.displayOnTimedDelay > 0;
        var urlTargetingExactMatch = Boolean(dyno.targetingOptions.whiteList.exactMatchValues.length);
        var urlTargetingBeginsWith = Boolean(dyno.targetingOptions.whiteList.startsWithValues.length);
        var urlTargetingQueryParam = Boolean(Object.keys(dyno.targetingOptions.whiteList.queryParamFilterValues).length);
        var urlTargetingContains = Boolean(dyno.targetingOptions.whiteList.containsValues.length);
        var urlTargetingBlacklist = Boolean(dyno.targetingOptions.blackList.containsValues.length) && Boolean(dyno.targetingOptions.blackList.exactMatchValues.length) && Boolean(Object.keys(dyno.targetingOptions.blackList.queryParamFilterValues).length) && Boolean(dyno.targetingOptions.blackList.startsWithValues.length);
        var urlTargetingBlank = !urlTargetingBlacklist && !urlTargetingContains && !urlTargetingQueryParam && !urlTargetingBeginsWith && !urlTargetingExactMatch;
        var hasFeatures = (0, _underscore.compact)([urlTargetingBlacklist ? 'url-targeting-blacklist' : null, urlTargetingContains ? 'url-targeting-contains' : null, urlTargetingQueryParam ? 'url-targeting-query-param' : null, urlTargetingBeginsWith ? 'url-targeting-begins-with' : null, urlTargetingExactMatch ? 'url-targeting-exact-match' : null, urlTargetingBlank ? 'url-targeting-blank' : null, displayOnTimedDelay ? 'display-on-timed-delay' : null, displayOnScroll ? 'display-on-scroll' : null, displayOnMobile ? 'display-on-mobile' : null, displayOnExitIntent ? 'display-on-exit-intent' : null, singleFollowUpEmail ? 'single-follow-up-email' : null, multiFollowUpEmail ? 'multi-follow-up-email' : null, language ? "locale-" + language : null, featuredImage ? 'featured-image' : null, calloutBody ? 'callout-body' : null, formBody ? 'form-body' : null, redirectType !== 'disabled' ? "redirect-type-" + redirectType : null, typeof calloutType !== 'undefined' && calloutType !== 'disabled' ? "callout-type-" + calloutType : null, type ? "type-" + type : null]); // ********** PUBLIC EVENT **********
        // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
        // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
        // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation

        (0, _eventsTrackerUtils.trackEditorInteraction)('publish-lead-flow', {
          'has-features': hasFeatures
        });
      } catch (err) {
        (0, _eventsTrackerUtils.trackEditorInteraction)('publish-lead-flow');
      }
    }, function (error) {
      dispatch(saveDynoError(error.xhr));

      if ((0, _DynoUtils.errorIsBadRequest)(error.xhr)) {
        var errorResponse = JSON.parse(error.xhr.response);
        var field = (0, _DynoUtils.getFieldForError)(errorResponse);
        dispatch(addValidationErrorIfNeeded(_DynoEditor.FIELDS_TO_STEP[field], field, "leadFlowEditor.error." + errorResponse.errorType));
      }

      (0, _eventsTrackerUtils.trackEditorError)('publish-lead-flow-failure');
    }).done();
  };
}

function getDraftChangesIfNeeded() {
  return function (dispatch, getState) {
    var dyno = (0, _Dynos2.getEditableDyno)(getState());

    if (dyno.draft && !dyno.changes) {
      return _DynosApiClient.default.getDynoDraft(dyno).then(function (response) {
        dispatch(saveDraftSuccess(response));
      });
    }

    return null;
  };
}

function saveDynoChangesToDraft() {
  return function (dispatch, getState) {
    var editableDyno = (0, _Dynos2.getEditableDyno)(getState());

    if (!editableDyno.id) {
      return null;
    }

    dispatch(saveDynoDraft());
    var dyno = Object.assign({}, editableDyno, {
      draft: true
    });
    return _DynosApiClient.default.putDynoAsDraft(dyno).then(function (response) {
      dispatch(saveDraftSuccess(response));
      (0, _eventsTrackerUtils.trackEditorInteraction)('saved-lead-flow-draft');
      dispatch((0, _Dynos.receiveDynoById)(response));
    }, function (error) {
      dispatch(saveDraftError(error.xhr));

      if ((0, _DynoUtils.errorIsBadRequest)(error.xhr)) {
        var errorResponse = JSON.parse(error.xhr.response);
        var fields = (0, _DynoUtils.getFieldsForSaveDraftError)(errorResponse.message) || [];

        if (errorResponse.errorType === 'NAME_NOT_UNIQUE') {
          dispatch(addValidationErrorIfNeeded('options', 'name', 'leadFlowEditor.leadFlowOptionsEditor.error.duplicatedName'));
        } else {
          fields.forEach(function (field) {
            var step = _DynoEditor.FIELDS_TO_STEP[field];

            if (step === 'follow-up') {
              validateKickbackEmails(dispatch, field, getState());
            } else {
              dispatch(addValidationErrorIfNeeded(step, field, "leadFlowEditor.error." + errorResponse.errorType));
            }
          });
        }
      }

      (0, _eventsTrackerUtils.trackEditorInteraction)('saved-lead-flow-draft-failure');
    }).done();
  };
}

var autoSaveDraft = (0, _underscore.debounce)(function (dispatch, getState) {
  var _getState = getState(),
      allGates = _getState.allGates;

  var dynosEditor = (0, _Dynos2.getDynosEditor)(getState());
  var editorValidation = (0, _Dynos2.getEditorValidation)(getState());
  var hasValidationErrors = Boolean(Object.keys(editorValidation).length);
  var errors = (0, _DynoValidationUtils.validateEditableDyno)(dynosEditor, allGates);

  if (!hasValidationErrors && errors.length === 0) {
    dispatch(saveDynoChangesToDraft());
  } else {
    dispatch(cancelAutoSaveDyno());
  }
}, 3000);

function setFormFields(formFields) {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.SET_FORM_FIELDS,
      payload: formFields
    });
    var includesPhone = (0, _underscore.any)(formFields, function (field) {
      return field.name === _FormFieldTypes.default.PHONE;
    });
    var includesNames = (0, _underscore.any)(formFields, function (field) {
      return field.name === _FormFieldTypes.default.FIRSTNAME || field.name === _FormFieldTypes.default.LASTNAME;
    });
    dispatch(updateDyno({
      formFields: formFields,
      showPhone: includesPhone,
      showNames: includesNames
    }, true));
  };
}

function addFormField(field) {
  return function (dispatch, getState) {
    dispatch({
      type: _ActionTypes.ADD_FORM_FIELD,
      payload: field
    });
    var existingFields = (0, _Dynos2.getFormFields)(getState()); // Give the new field an order.

    var newFieldList = (0, _FormFieldUtils.appendFormField)(existingFields, field);
    dispatch(setFormFields(newFieldList));
  };
}

function removeFormField(fieldName) {
  return function (dispatch, getState) {
    var existingFields = (0, _Dynos2.getFormFields)(getState());
    var newFieldList = (0, _underscore.filter)(existingFields, function (field) {
      return field.name !== fieldName;
    });
    newFieldList = fixFormFieldOrders(newFieldList);
    dispatch(setFormFields(newFieldList));
  };
}

function editFormField(fieldName, value) {
  return function (dispatch, getState) {
    var existingFields = (0, _Dynos2.getFormFields)(getState());
    var fieldToEdit = existingFields.find(function (field) {
      return field.name === fieldName;
    });
    var newFieldList = (0, _underscore.filter)(existingFields, function (field) {
      return field.name !== fieldName;
    });
    var newField = Object.assign({}, fieldToEdit, value);
    newFieldList.push(newField);
    dispatch(setFormFields(fixFormFieldOrders(newFieldList)));
  };
}

function editFormFieldValidation(fieldName, value) {
  return function (dispatch, getState) {
    var existingFields = (0, _Dynos2.getFormFields)(getState());
    var fieldToEdit = existingFields.find(function (field) {
      return field.name === fieldName;
    });
    var validation = Object.assign({}, fieldToEdit.validation || {}, value);
    var newFieldList = (0, _underscore.filter)(existingFields, function (field) {
      return field.name !== fieldName;
    });
    var newField = Object.assign({}, fieldToEdit, {
      validation: validation
    });
    newFieldList.push(newField);
    dispatch(setFormFields(fixFormFieldOrders(newFieldList)));
  };
}

function moveFormField(fieldName, newOrder) {
  return function (dispatch, getState) {
    var newFields = (0, _underscore.clone)((0, _Dynos2.getFormFields)(getState()));
    newFields.forEach(function (field) {
      if (field.name === fieldName) {
        // We found the field we want to move, so move it.
        field.displayOrder = newOrder;
      } else if (field.displayOrder >= newOrder) {
        // Increment all fields with a higher-number order.
        field.displayOrder += 1;
      }
    }); // The order values represent the order we want,
    // but we might have gaps or the list might not start at 0.

    newFields = fixFormFieldOrders(newFields);
    dispatch(setFormFields(newFields));
  };
}

function fetchKickbackPreview(id, emailData, locale) {
  return _DynosApiClient.default.fetchKickbackPreview(id, emailData, locale);
}

function fetchKickbackPreviews(id, emailData, locale) {
  return function (dispatch) {
    dispatch(requestKickbacks());
    var previews = (0, _underscore.map)(emailData, function (mail) {
      return fetchKickbackPreview(id, mail.emailData, locale);
    });
    Promise.all(previews).then(function (responses) {
      dispatch(receiveKickbackPreviews(responses));
    }).catch(function (err) {
      dispatch(errorKickbacks(err.status));
    });
  };
}